import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';

const apiUrl = process.env.REACT_APP_API_URL;

function AdminAddBatch() {
  const [courses, setCourses] = useState([]);
  const [courseid, setCourseid] = useState('');
  const [batchname, setBatchname] = useState('');
  const [rollingEnrollment, setRollingEnrollment] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to add a batch.');
        setMessageType('error');
        return;
      }

      const response = await axios.get(`${apiUrl}/api/admin/courses-dropdown`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });

      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        setMessage(response.data.message || 'Failed to fetch courses.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error fetching courses.');
      setMessageType('error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setMessageType('');

    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to add a batch.');
        setMessageType('error');
        setLoading(false);
        return;
      }

      const response = await axios.post(
        `${apiUrl}/api/admin/batches`,
        { courseid, batchname, rolling_enrollment: rollingEnrollment ? 1 : 0 },
        { headers: { Authorization: `Bearer ${sessionData.token}` } }
      );

      if (response.data.success) {
        setMessage('Batch added successfully!');
        setMessageType('success');
        setCourseid('');
        setBatchname('');
        setRollingEnrollment(false);
        setTimeout(() => navigate('/admin-view-batches'), 2000);
      } else {
        setMessage(response.data.message || 'Failed to add batch.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error adding batch.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link to="/admin-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Add Batch</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-24">
              <h4 className="mb-16">Add New Batch</h4>
              {message && (
                <div className={`alert alert-${messageType} mb-16`}>
                  {message}
                </div>
              )}
              <form onSubmit={handleSubmit} className="mb-24">
                <div className="mb-3">
                  <label htmlFor="courseid" className="form-label">Course</label>
                  <select
                    className="form-control"
                    id="courseid"
                    value={courseid}
                    onChange={(e) => setCourseid(e.target.value)}
                    required
                  >
                    <option value="">Select Course</option>
                    {courses.map((course) => (
                      <option key={course.id} value={course.id}>
                        {course.coursename}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label htmlFor="batchname" className="form-label">Batch Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="batchname"
                    value={batchname}
                    onChange={(e) => setBatchname(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="rollingEnrollment"
                    checked={rollingEnrollment}
                    onChange={(e) => setRollingEnrollment(e.target.checked)}
                  />
                  <label htmlFor="rollingEnrollment" className="form-check-label">
                    Rolling batch
                  </label>
                  <div className="text-gray-500 text-13 mt-4">
                    Students added to this batch only see lessons dated on or after the day
                    they join — not the classes uploaded before them. Use this for a single
                    ongoing batch per course instead of creating a new batch each cycle.
                    Leave unchecked for a normal batch (everyone sees every lesson).
                  </div>
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Adding...' : 'Add Batch'}
                </button>
              </form>

              {/* Batch List (if needed, but since it's add page, perhaps omit or add a view link) */}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default AdminAddBatch;